import { Flex, Spin } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { LoaderMask } from "./Styled";

interface LoadingProps {
    title?: string;
}

export const Loading: FC<LoadingProps> = ({ title = "Завантаження" }) => {
    return (
        <LoaderMask>
            <Flex vertical gap={16}>
                <PrimaryText>{title}</PrimaryText>
                <Spin size="large" />
            </Flex>
        </LoaderMask>
    );
};
